import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'

function DestinationZoneTopBar(props) {
    return (
        <div className="cats-all-btns justify-content-between d-flex border-bottom st-border-light pad-15-R">
            <div className="cats-all-btns-inner d-flex flex-wrap justify-content-start  pad-12-B ">
                <div className="app-header-wrapper heading-md d-flex align-items-center justify-content-start customer-top-heading mb-0">
                    <p className="app-heading text-capitalize">Destination Zones</p>
                </div>
            </div>
            <div className="cats-all-btns-inner d-flex flex-wrap justify-content-end pad-12-B customer-right-btn">
                <Button className="st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2"
                >
                    Delete
                </Button>
                <Button
                    type="submit"
                    className={`st-btn st-btn-sm st-btn-primary d-flex align-items-center justify-content-center`} // ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}
                >
                    <FeatherIcon
                        icon="plus"
                        size="14"
                        className="icon me-1" />
                    Add New Zone
                </Button>
            </div>
        </div >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(DestinationZoneTopBar)